<template>
  <div class="admin-schedule-bars">
    <header-title title="Horarios de Cartas Principales"></header-title>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

    <schedule
      title="Horario Bebidas"
      :display="display"
      :schedule-collection="mapScheduleDrinks"
      @saveSchedule="saveDrinksHour"
    />

    <schedule
      title="Horario Comidas"
      :display="display"
      :schedule-collection="mapScheduleFood"
      @saveSchedule="saveFoodHour"
    />

    <schedule
      title="Horario Postres"
      :display="display"
      :schedule-collection="mapScheduleDessert"
      @saveSchedule="saveDessertHour"
    />
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import Schedule from "@/components/admin/schedule/Schedule.vue";
import {
  scheduleFoodCollection,
  updateScheduleFood
} from "@/collections/scheduleFood";
import {
  scheduleDrinksCollection,
  updateScheduleDrink
} from "@/collections/scheduleDrinks";
import {
  scheduleDessertCollection,
  updateScheduleDessert
} from "@/collections/scheduleDessert";

const DAYS = [
  {
    name: "Lunes",
    value: 1
  },
  {
    name: "Martes",
    value: 2
  },
  {
    name: "Miercoles",
    value: 3
  },
  {
    name: "Jueves",
    value: 4
  },
  {
    name: "Viernes",
    value: 5
  },
  {
    name: "Sabado",
    value: 6
  },
  {
    name: "Domingo",
    value: 0
  }
];

export default {
  name: "ScheduleMain",
  components: { Loader, HeaderTitle, Schedule },
  data() {
    return {
      days: DAYS,
      display: false,
      scheduleDrinks: [],
      scheduleFood: [],
      scheduleDessert: [],
      dialogLoader: true
    };
  },
  firestore() {
    return {
      scheduleDrinks: scheduleDrinksCollection,
      scheduleFood: scheduleFoodCollection,
      scheduleDessert: scheduleDessertCollection
    };
  },
  mounted() {
    let self = this;

    setTimeout(() => {
      self.display = true;
      this.dialogLoader = false;
    }, 300);
  },
  computed: {
    mapScheduleFood() {
      let scheduleFood = JSON.parse(JSON.stringify(this.scheduleFood));
      scheduleFood.push(scheduleFood.shift());
      return scheduleFood;
    },
    mapScheduleDrinks() {
      let scheduleDrinks = JSON.parse(JSON.stringify(this.scheduleDrinks));
      scheduleDrinks.push(scheduleDrinks.shift());
      return scheduleDrinks;
    },
    mapScheduleDessert() {
      let scheduleDessert = JSON.parse(JSON.stringify(this.scheduleDessert));
      scheduleDessert.push(scheduleDessert.shift());
      return scheduleDessert;
    }
  },
  methods: {
    async saveFoodHour(event, schedule, day, range, shift) {
      try {
        schedule[shift][range] = parseFloat(event);
        await updateScheduleFood(schedule.id, schedule);
        this.showSuccesMessage();
      } catch (error) {
        this.setlogError(
          "update_schedule_food",
          "Obtained error message in saveFoodHour()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    async saveDrinksHour(event, schedule, day, range, shift) {
      try {
        schedule[shift][range] = parseFloat(event);
        await updateScheduleDrink(schedule.id, schedule);
        this.showSuccesMessage();
      } catch (error) {
        this.setlogError(
          "update_schedule_drink",
          "Obtained error message in saveDrinksHour()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    async saveDessertHour(event, schedule, day, range, shift) {
      try {
        schedule[shift][range] = parseFloat(event);
        await updateScheduleDessert(schedule.id, schedule);
        this.showSuccesMessage();
      } catch (error) {
        this.setlogError(
          "update_schedule_dessert",
          "Obtained error message in saveDessertHour()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    showSuccesMessage() {
      this.showSuccessMessage("Se ha actualizado la hora");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
